export const AIS3_SCENARIO_SETTINGS_API_PREFIX = 'ais3.scenario.notification.settings';
